module.exports = __webpack_public_path__ + "static/media/paneer.60816264.jpg";